/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Authorization,
    AuthorizationFromJSON,
    AuthorizationFromJSONTyped,
    AuthorizationToJSON,
    Page,
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ListAuthorizationsPageResponse
 */
export interface ListAuthorizationsPageResponse {
    /**
     * 
     * @type {Page}
     * @memberof ListAuthorizationsPageResponse
     */
    paging?: Page;
    /**
     * 
     * @type {Array<Authorization>}
     * @memberof ListAuthorizationsPageResponse
     */
    data?: Array<Authorization>;
}

export function ListAuthorizationsPageResponseFromJSON(json: any): ListAuthorizationsPageResponse {
    return ListAuthorizationsPageResponseFromJSONTyped(json, false);
}

export function ListAuthorizationsPageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAuthorizationsPageResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paging': !exists(json, 'paging') ? undefined : PageFromJSON(json['paging']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(AuthorizationFromJSON)),
    };
}

export function ListAuthorizationsPageResponseToJSON(value?: ListAuthorizationsPageResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paging': PageToJSON(value.paging),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(AuthorizationToJSON)),
    };
}


